import { Box, Grid, Typography } from '@mui/material';
import ColorPicker from 'components/ColorPicker/ColorPicker';
import { Control, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateGuiVersionType } from 'types/compobotGuiVersion.type';
import { PRETEXT_MAX_LENGTH } from '../constants';
import WordCounterField from '../WordCounterField';

interface PretextSectionProps {
  control: Control<CreateGuiVersionType>;
  errors: FieldErrors<CreateGuiVersionType>;
  pretextEnCount: number;
  pretextHuCount: number;
  setPretextEnCount: (count: number) => void;
  setPretextHuCount: (count: number) => void;
  pretextColor?: string;
  onPretextColorChange?: (color: string) => void;
}

export default function PretextSection({
  control,
  errors,
  pretextEnCount,
  pretextHuCount,
  setPretextEnCount,
  setPretextHuCount,
  pretextColor = '',
  onPretextColorChange = () => {
    /* no-op */
  },
}: PretextSectionProps) {
  const { t } = useTranslation();

  return (
    <Grid item xs={12}>
      <Typography
        variant="subtitle1"
        sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}
      >
        {t('createGuiVersionPage.pretext')}
        <ColorPicker value={pretextColor} onChange={onPretextColorChange} />
      </Typography>

      <Box display="flex" gap={2} width="100%">
        <Box flex="1">
          <WordCounterField
            name="pretextEn"
            control={control}
            errors={errors}
            label={t('createGuiVersionPage.pretextEn')}
            maxLength={PRETEXT_MAX_LENGTH}
            currentCount={pretextEnCount}
            onCountChange={setPretextEnCount}
          />
        </Box>
        <Box flex="1">
          <WordCounterField
            name="pretextHu"
            control={control}
            errors={errors}
            label={t('createGuiVersionPage.pretextHu')}
            maxLength={PRETEXT_MAX_LENGTH}
            currentCount={pretextHuCount}
            onCountChange={setPretextHuCount}
          />
        </Box>
      </Box>
    </Grid>
  );
}
